import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=12d8f433"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports